import { useState } from "react";
import PropTypes from 'prop-types';
import ReactFileReader from "react-file-reader";
import Avatar from '@mui/material/Avatar';

export default function FilePicker({ onUploadImage, width = 700, height = 542 }) {
    const [url, setUrl] = useState(null);

    const handleFiles = (files) => {
        setUrl(files.base64);
        if (onUploadImage && files.fileList[0]) {
            onUploadImage({
                content: files.base64.split("base64,")[1],
                name: files.fileList[0].name,
                contentType: files.fileList[0].type,
            });
        }
    };

    return (
        <>
            <ReactFileReader fileTypes={[".png", ".jpg"]} base64={true} handleFiles={handleFiles} >
                <Avatar sx={{ width: width, height: height }} variant="square" src={url} />
            </ReactFileReader>
        </>
    );
}

FilePicker.propTypes = {
    onUploadImage: PropTypes.func.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
};